import { createTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    challenge: Palette["primary"];
    challengeBox: {
      background: string;
      border: string;
      icon: string;
    };
  }
  interface PaletteOptions {
    challenge?: PaletteOptions["primary"];
    challengeBox?: {
      background?: string;
      border?: string;
      icon?: string;
    };
  }
}

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#F5C518", // 🟡 "Amarillo construcción"
      light: "#ffdf5c", // 🟡 "Amarillo claro"
      dark: "#A4870F", // 🟠 "Amarillo oscuro"
      contrastText: "#111111", // ⚫ "Texto sobre amarillo"
    },
    secondary: {
      main: "#FFFFFF", // ⚪ "Blanco puro"
      dark: "#e0e0e0", // ⚪ "Gris claro"
      contrastText: "#111111", // ⚫ "Texto sobre blanco"
    },
    background: {
      default: "#0d0d0d", // ⚫ "Fondo general"
      paper: "#383838", // ⚫ "Fondo tarjetas/paneles"
    },
    text: {
      primary: "#ffffff", // ⚪ "Texto principal"
      secondary: "#bdbdbd", // ⚪ "Texto secundario"
      disabled: "#757575", // ⚫ "Texto desactivado"
    },
    grey: {
      100: "#e0e0e0", // ⚪ "Gris claro"
      200: "#F5C518", // 🟡 "Amarillo construcción"
    },
    warning: {
      main: "#FF9800", // "naranja" para íconos o alertas
    },
    divider: grey[600],
    tonalOffset: 0.2,
    challenge: {
      main: "#df7a87",
      light: "#e89aa5", // opcional
      dark: "#b85c68", // opcional
      contrastText: "#ffffff", // para texto encima
    },
    challengeBox: {
      background: "#402529",
      border: "#733943",
      icon: "#bd5160",
    },
  },

  typography: {
    fontFamily: `'Inter', sans-serif`,
    h1: {
      fontSize: "3rem",
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: "2.5rem",
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "0.875rem", // 👈 body2 style for small screens
      lineHeight: 1.6,
      [`@media (min-width:900px)`]: {
        fontSize: "1.15rem", // 👈 actual body1 for md+
      },
    },
    body2: {
      fontSize: "0.875rem",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "0.5px",
    },
    subtitle1: {
      color: grey[300],
      fontSize: "0.9rem",
    },
  },

  spacing: 8, // 1 = 8px
  shape: {
    borderRadius: 12, // más suavizado en cards/botones
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "10px 20px",
          fontWeight: 600,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 0 0 2px rgba(245,197,24,0.3)",
          },
        },
      },
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a1a",
          padding: "1.5rem",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a1a",
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#fff",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: "#F5C518",
          textUnderlineOffset: 4,
          "&:hover": {
            color: "#ffdf5c",
            textDecoration: "underline",
          },
        },
      },
    },
  },
});

export default theme;
